import React, { MouseEvent } from "react";
import DataGrid, {
    Pager,
    Paging,
    FilterRow,
    Column,
    Search,
    Export,
    SearchPanel,
    Editing,
    Texts,
    HeaderFilter,
    GroupPanel,
    FilterPanel,
    Scrolling
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { LoadIndicator, LoadPanel } from "devextreme-react";
import VenueProviderService from "../../services/VenueProviderService";
import MaskedStatusForActive from "../ServiceFeeMatrix/MaskedStatusForActive";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrashAlt } from "@fortawesome/pro-regular-svg-icons";
import { confirm } from "devextreme/ui/dialog";
import { onExportingEvent } from "../../types/DevExtremeTypes";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";
import { buildRequestParameters } from "../../services/RemoteOperationsService"; // adjust path if needed
import MaskedStatusForActiveNew from "../ServiceFeeMatrix/MaskedStatusForActiveNew";
interface ProviderServiceGridProps {
    refreshSignal: boolean;
}

interface ProviderServiceGridState {
    dataSource: any;
    loadPanelVisible: boolean;
    showProgressIndicator: boolean;
}

class ProviderServiceGrid extends React.Component<ProviderServiceGridProps, ProviderServiceGridState> {
    venueProviderService: VenueProviderService;
    remoteOperations: {
        sorting: boolean,
        paging: boolean,
        filtering: boolean,
        grouping: boolean,
        summary: boolean
    }
    dataGrid:any;
    gridRef:any;
    constructor(props: ProviderServiceGridProps) {
        super(props);
        this.venueProviderService = new VenueProviderService();
        this.dataGrid = null;
        this.gridRef = null;
        this.state = {
            dataSource: null,
            loadPanelVisible: false,
            showProgressIndicator: false,
        };
        this.remoteOperations = {
            sorting: true,
            paging: true,
            filtering: true,
            grouping: true,
            summary: false
        }
    }

    componentDidMount() {
        this.loadRemoteDataSource();
    }

    componentDidUpdate(prevProps: ProviderServiceGridProps) {
        if (this.props.refreshSignal !== prevProps.refreshSignal) {
            this.loadRemoteDataSource();
        }
    }

    loadRemoteDataSource = () => {
        const remoteDataSource = new CustomStore({
            key: "id",
            load: (loadOptions) => this.getRemoteData(loadOptions),
        });

        this.setState({ dataSource: remoteDataSource });
    };


getRemoteData = (loadOptions: any) => {
    const queryParams = buildRequestParameters(loadOptions);

    return this.venueProviderService
        .getVenueProviderDataItem(queryParams)
        .then((response) => {
            const rawData = response?.data;

            const safeData = Array.isArray(rawData?.data) ? rawData.data : [];
            const safeTotalCount = typeof rawData?.totalCount === 'number' ? rawData.totalCount : safeData.length;

            return {
                data: safeData,
                totalCount: safeTotalCount
            };
        })
        .catch((error) => {
            console.error("Data Load Error:", error);
            throw new Error("Data Loading Error");
        });
};
;



    handleDeleteOnClick = (id: number) => {
        confirm("<div class='text-center'>Delete this row?</div>", "Delete").then((hasConfirmed) => {
            if (hasConfirmed) {
                this.setState({ loadPanelVisible: true });
                this.venueProviderService.deleteVenueProviderDataItem(id).then(() => {
                    this.loadRemoteDataSource();
                    this.setState({ loadPanelVisible: false });
                });
            }
        });
    };

    editDeleteCellRender = (cellInfo: any) => (
        <div className="d-flex justify-content-between align-items-center">
            <Link
                title="Delete"
                className="icon-btn"
                onClick={(e: MouseEvent) => {
                    e.preventDefault();
                    this.handleDeleteOnClick(cellInfo.data.id);
                }}
                to="#"
            >
                <FontAwesomeIcon icon={faTrashAlt} />
            </Link>
            <Link
                title="Edit"
                className="icon-btn"
                to={{ pathname: "/matrixView", state: { id: cellInfo.data.id?.toString(), isEdit: true } }}
            >
                <FontAwesomeIcon icon={faPen} />
            </Link>
        </div>
    );

    onExporting = (e: onExportingEvent) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({ component: e.component, worksheet, autoFilterEnabled: true }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DataGrid.xlsx");
            });
        });
        e.cancel = true;
    };

    render() {
        return (
            <div>
                {this.state.showProgressIndicator ? (
                    <LoadIndicator id="remote-grid-indicator" height={100} width={100} visible={true} />
                ) : (
                    <>
                        <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadPanelVisible} />
                        <DataGrid
                        elementAttr={{
                                            id: "gridContainer"
                                        }}
                            dataSource={this.state.dataSource}
                            showBorders={false}
                            showColumnLines={false}
                            hoverStateEnabled={true}
                            columnAutoWidth={true}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            columnResizingMode="widget"
                            onExporting={this.onExporting}
                                        wordWrapEnabled={false}
                                        remoteOperations={this.remoteOperations}
                                        noDataText={"No Data Found"}
                                        columnMinWidth={100}
                                        ref={(ref) => { this.dataGrid = ref; }}
                        >
                            <Editing>
                                <Texts confirmDeleteMessage="" />
                            </Editing>
                            <SearchPanel visible={true} placeholder="Search" />
                                        <Scrolling useNative={true} showScrollbar={"always"} />
                            <HeaderFilter visible={true}>
                                            <Search enabled={true} />
                                        </HeaderFilter>
                            <Export enabled={true} allowExportSelectedData={false} />
                            <Paging defaultPageSize={10} />
                            <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20]} showInfo={true} />

                            <Column dataField="id" caption="ID" />
                            <Column dataField="providerBusinessEntity.shortName" caption="PROVIDER" />
                            <Column dataField="venue.businessEntity.shortName" caption="CLIENT" />
                            <Column dataField="venue.venueName" caption="VENUE" />
                            <Column dataField="venue.houseNumber" caption="HOUSE NO" />
                            <Column dataField="serviceTypeLookUp.value" caption="SERVICE" />
                            <Column dataField="serviceSubTypeLookUp.value" caption="SUB TYPE" />
                            <Column dataField="venue.city" caption="TOWN/CITY" />
                            <Column dataField="venue.county" caption="COUNTY" />
                            <Column dataField="venue.postCode" caption="POST CODE" />
                            <Column dataField="active" caption="ACTIVE" cellComponent={MaskedStatusForActiveNew} />
                            <Column dataField="lastUpdatedOn" caption="LAST UPDATED" format="dd/MM/yyyy" dataType="date" />
                            <Column dataField="lastUpdatedBy" caption="LAST UPDATED BY" />
                            <Column cellRender={this.editDeleteCellRender} />
                            <FilterRow visible={true} applyFilter="auto" />
                                        <GroupPanel visible={true} />
                                        <FilterPanel visible={true} />
                            
                        </DataGrid>
                    </>
                )}
            </div>
        );
    }
}

export default ProviderServiceGrid;